export const PUBLISH_DRAFTS_COLLECTION = 'publish_drafts';

const mapCloudDraftDoc = (doc) => ({
  id: doc.draftId || doc._id,
  cloudDocId: doc._id,
  name: doc.name || '未命名草稿',
  formData: doc.formData || {},
  savedAt: doc.savedAt || doc.createdAt || Date.now(),
  updatedAt: doc.updatedAt || doc.savedAt || Date.now()
});

export const mergePublishDraftLists = (localDrafts = [], cloudDrafts = []) => {
  const map = new Map();
  [...localDrafts, ...cloudDrafts].forEach((draft) => {
    if (!draft?.id) return;
    const key = String(draft.id);
    const prev = map.get(key);
    const ts = Number(draft.updatedAt || draft.savedAt || 0);
    const prevTs = Number(prev?.updatedAt || prev?.savedAt || 0);
    if (!prev || ts >= prevTs) map.set(key, draft);
  });
  return Array.from(map.values()).sort(
    (a, b) => (b.updatedAt || b.savedAt || 0) - (a.updatedAt || a.savedAt || 0)
  );
};

export const fetchCloudPublishDrafts = async (db, ensureAuth, phone) => {
  if (!db || !phone) return [];
  try {
    if (typeof ensureAuth === 'function') await ensureAuth();
    const res = await db
      .collection(PUBLISH_DRAFTS_COLLECTION)
      .where({ ownerPhone: String(phone) })
      .limit(100)
      .get();
    return (res.data || []).map(mapCloudDraftDoc);
  } catch (error) {
    console.warn('云库草稿读取失败:', error);
    return [];
  }
};

export const upsertCloudPublishDraft = async (db, ensureAuth, phone, draft) => {
  if (!db || !phone || !draft?.id) return false;
  try {
    if (typeof ensureAuth === 'function') await ensureAuth();
    const payload = {
      draftId: String(draft.id),
      ownerPhone: String(phone),
      name: draft.name || '未命名草稿',
      formData: draft.formData || {},
      savedAt: draft.savedAt || Date.now(),
      updatedAt: draft.updatedAt || Date.now()
    };
    const existing = await db
      .collection(PUBLISH_DRAFTS_COLLECTION)
      .where({ ownerPhone: String(phone), draftId: String(draft.id) })
      .limit(1)
      .get();
    if (existing?.data?.length) {
      await db.collection(PUBLISH_DRAFTS_COLLECTION).doc(existing.data[0]._id).update(payload);
    } else {
      await db.collection(PUBLISH_DRAFTS_COLLECTION).add({
        ...payload,
        createdAt: Date.now()
      });
    }
    return true;
  } catch (error) {
    console.warn('云库草稿写入失败:', error);
    return false;
  }
};

export const deleteCloudPublishDrafts = async (db, ensureAuth, phone, draftIds = []) => {
  if (!db || !phone || !draftIds.length) return 0;
  try {
    if (typeof ensureAuth === 'function') await ensureAuth();
    let removed = 0;
    for (const draftId of draftIds) {
      const res = await db
        .collection(PUBLISH_DRAFTS_COLLECTION)
        .where({ ownerPhone: String(phone), draftId: String(draftId) })
        .limit(5)
        .get();
      for (const doc of res.data || []) {
        await db.collection(PUBLISH_DRAFTS_COLLECTION).doc(doc._id).remove();
        removed += 1;
      }
    }
    return removed;
  } catch (error) {
    console.warn('云库草稿删除失败:', error);
    return 0;
  }
};

export const syncAllDraftsToCloud = async (db, ensureAuth, phone, drafts = []) => {
  if (!db || !phone) return 0;
  let ok = 0;
  for (const draft of drafts) {
    const success = await upsertCloudPublishDraft(db, ensureAuth, phone, draft);
    if (success) ok += 1;
  }
  return ok;
};
